import { animate, style, transition, trigger } from '@angular/animations';
import { ConnectedPosition } from '@angular/cdk/overlay';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Subject, combineLatest, firstValueFrom, takeUntil, timer } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { DividendVipService } from 'src/app/pages/dividend-vip/dividend-vip.service';
import { MenuItem } from 'src/app/pages/user-center/left-menu.config';
import { CardCenterService } from 'src/app/pages/voucher-center/card-center/card-center.service';
import { VipApi } from 'src/app/shared/apis/vip.api';
import { AccountInforData } from 'src/app/shared/interfaces/account.interface';
import { CurrenciesInterface } from 'src/app/shared/interfaces/deposit.interface';
import { UserDetail } from 'src/app/shared/interfaces/vip.interface';
import { ChatService } from 'src/app/shared/service/chat.service';
import { LayoutService } from 'src/app/shared/service/layout.service';
import { LocaleService } from 'src/app/shared/service/locale.service';
import { PopupService } from 'src/app/shared/service/popup.service';
import { ToastService } from 'src/app/shared/service/toast.service';
@UntilDestroy()
@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss'],
  animations: [
    trigger('expansion', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate('0.2s ease-in-out', style({ opacity: 1, transform: 'translateY(0)' })),
      ]),
      transition(':leave', [animate('0.2s ease-in-out', style({ opacity: 0, transform: 'translateY(20px)' }))]),
    ]),
    trigger('toggle', [
      transition('* => *', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate('0.3s ease-out', style({ opacity: 1, transform: 'translateY(0)' })),
      ]),
    ]),
  ],
})
export class TopBarComponent implements OnInit {
  constructor(
    public appService: AppService,
    public layout: LayoutService,
    private route: ActivatedRoute,
    private localService: LocaleService,
    private toast: ToastService,
    private cardCenterService: CardCenterService,
    private router: Router,
    private popup: PopupService,
    private vipApi: VipApi,
    public chatService: ChatService,
    private dividendVipService: DividendVipService,
  ) {}

  isH5!: boolean;
  logined!: boolean; //是否登陆状态
  userInfo!: AccountInforData | null;

  /**@bounsCount 卡券数量 */
  bounsCount: number = 0;

  selectMenuItemIndex = 0;
  selectInnerIndex = 0;
  menuRight = [
    {
      title: this.localService.getValue('deposit'),
      page: 'deposit',
      active: true,
      detail: [
        {
          title: this.localService.getValue('crypto_topup'),
          page: 'deposit',
          type: 'd-crypto',
          active: false,
        },
        {
          title: this.localService.getValue('currency_topup'),
          page: 'deposit',
          type: 'd-fiat',
          active: false,
        },
        {
          title: this.localService.getValue('purchase_topup'),
          page: 'deposit',
          type: 'purchase',
          active: false,
        },
      ],
    },
    {
      title: this.localService.getValue('withdraw'),
      page: 'withdraw',
      active: false,
      detail: [
        {
          title: this.localService.getValue('currency_withdraw'),
          page: 'withdraw',
          type: 'w-fiat',
          active: false,
        },
        {
          title: this.localService.getValue('crypto_withdraw'),
          page: 'withdraw',
          type: 'w-crypto',
          active: false,
        },
      ],
    },
  ];
  currentRightPage = this.menuRight[this.selectMenuItemIndex]?.detail[this.selectInnerIndex].type;
  @ViewChild('rightAsidePopup') rightAsidePopup!: TemplateRef<any>;
  rightAsideDialog?: MatDialogRef<any>;

  /** 当前有多少信息未读 */
  carsNumber: number = 0;

  expanded?: boolean = false;
  position: ConnectedPosition[] = [
    { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top', panelClass: 'overlay-expansion' },
  ];

  topMenu: MenuItem[][] = [
    [
      {
        title: 'perssonal_center',
        icon: 'my',
        page: '/personal-center',
      },
      {
        title: 'account_management',
        page: '/global-settings/account',
        icon: 'account-shield',
      },
      {
        title: 'my_wallet_menu',
        page: '/my-wallet',
        icon: 'top-wallet',
      },
      {
        title: 'my_bet_menu',
        page: '/my-bet',
        icon: 'my-bet',
      },
      {
        title: 'trans_history',
        page: '/transaction',
        icon: 'transactions',
      },
    ],
    [
      {
        title: 'vip_club',
        page: 'vip',
        icon: 'vip-club',
      },
      {
        title: 'bonus_center',
        page: '/voucher/bonus',
        icon: 'card-center',
      },
      {
        title: 'gam_moderate',
        page: '/responsible-gambling/deposit-limit',
        icon: 'note',
        showOnlyCountry: true,
      },
      {
        title: 'refer_a_friend',
        page: '/referral/home',
        icon: 'recommend-user',
      },
    ],
    [
      {
        title: 'help_center',
        page: '/help-center',
        icon: 'help-center',
      },

      {
        title: 'preference_settings',
        page: '/global-settings/privacy',
        icon: 'global-settings',
      },
      {
        title: 'logout',
        page: 'logout',
        icon: 'logout',
      },
    ],
  ];
  /** 用戶細節 */
  userDetail?: UserDetail;
  /** 升级百分比 */
  percentage: string = '';
  /** 差多少分能升级（要先判断有值不然会报错） */
  diffPoints: number = 0;
  showPop$: Subject<boolean> = new Subject();
  currentCurrencyData?: CurrenciesInterface;

  @ViewChild('personnalDetails') personnalDetails!: TemplateRef<HTMLDivElement>;
  personalDetailPop?: MatDialogRef<unknown>;

  ngOnInit() {
    this.appService.userInfo$.pipe(untilDestroyed(this)).subscribe(x => {
      this.userInfo = x;
      this.logined = !!x;
      if (this.logined) {
        this.getUserDetail();

        this.topMenu.forEach(x => {
          x.forEach(e => {
            if (e.showOnlyCountry && (this.userInfo?.areaCode == '+599' || this.appService.countryCode == 'CW')) {
              e.showOnlyCountry = false;
            }
          });
        });
      }
    });
    this.topMenu.forEach(x => {
      x.forEach(y => {
        y.routerLink = `/${this.appService.languageCode}${y.page}`;
      });
    });
    this.layout.isH5$.pipe(untilDestroyed(this)).subscribe(e => {
      this.isH5 = e;
    });

    this.route.queryParamMap.pipe(untilDestroyed(this)).subscribe(queryParam => {
      const showRegister = queryParam.get('showRegister');
      showRegister && this.openRegisterDialog();
    });

    //订阅当前货币
    this.appService.currentCurrency$.pipe(untilDestroyed(this)).subscribe(v => {
      this.currentCurrencyData = v;
    });

    combineLatest([
      this.cardCenterService.bounsCount$,
      this.appService.noticeCounts$,
      this.dividendVipService.activityCount$,
    ])
      .pipe(untilDestroyed(this))
      .subscribe(([bounsNum, noticeNum, activityNum]) => {
        this.carsNumber = (bounsNum || 0) + (noticeNum?.All || 0) + (activityNum || 0);
      });
  }

  /**
   * 登陆出框
   */
  openLoginDialog(): void {
    this.router.navigate([], { relativeTo: this.route, fragment: 'login', queryParamsHandling: 'preserve' });
  }

  /**
   * 注册出框
   */
  openRegisterDialog(): void {
    this.router.navigate([], { relativeTo: this.route, fragment: 'register', queryParamsHandling: 'preserve' });
  }

  onShowWait() {
    this.toast.show({ message: this.localService.getValue('waiting'), type: 'success' });
  }
  toggleRightPopup() {
    this.chatService.toggleChat(this.isH5, false);
    const state = this.layout.rightCombinePupup$.getValue();
    this.layout.rightCombinePupup$.next(!state);
  }

  //展开
  handleOpen() {
    if (!this.userDetail) {
      return;
    }
    if (this.isH5) {
      this.personalDetailPop = this.popup.open(this.personnalDetails, {
        inAnimation: 'fadeInRight',
        outAnimation: 'fadeOutRight',
        speed: 'fast',
        autoFocus: false,
        isFull: true,
      });
      return;
    }
    this.chatService.toggleChat(this.isH5, false);
    this.showPop$.next(true);
    this.expanded = true;
    this.layout.mainContentBackdrop$.next(true);
  }

  handleClose(immediate: boolean = false) {
    if (this.isH5) {
      this.personalDetailPop?.close();
      return;
    }
    if (immediate) {
      this.expanded = false;
      this.layout.mainContentBackdrop$.next(false);
      return;
    }
    timer(150)
      .pipe(takeUntil(this.showPop$))
      .subscribe(_ => {
        this.expanded = false;
        this.layout.mainContentBackdrop$.next(false);
      });
  }

  /**
   * 切換菜單
   *
   * @param item
   * @param index
   */
  toMenu(item: any) {
    this.handleClose(true);
    if (item.page === 'logout') {
      /**
       * 登出
       */
      this.router.navigate([], { relativeTo: this.route }); //不加這段路由會出現 /zh-chlogout
      this.appService.logoutSubject$.next(true);
    } else if (item.page === 'vip') {
      this.router.navigate([], { relativeTo: this.route, fragment: 'vip' });
    } else {
      this.router.navigateByUrl(`/${this.appService.languageCode}${item.page}`);
    }
  }

  /**
   * 獲取vipc個人資訊
   */
  async getUserDetail() {
    this.userDetail = await firstValueFrom(this.vipApi.getUserDetail());
    if (this.userDetail) {
      // 获取档前订阅币种
      // this.currentCurrencyData = this.appService.currentCurrency$.getValue();
      this.appService.vipUserInfo$.next(this.userDetail);
      if (this.userDetail.nextLevelPoints != null && this.userDetail.currentPoints != null) {
        this.diffPoints = this.userDetail.nextLevelPoints;
        const percentage = this.userDetail.process;
        if (Number(percentage) >= 100) {
          this.percentage = '100%';
        } else {
          this.percentage = `${isNaN(Number(percentage)) ? 0 : percentage || 0}%`;
        }
      }
    }
  }
}
